import { clsx } from 'clsx'
import { Image } from 'component/Image'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { ItemDetails } from 'page/catalog/ItemPreview/ItemDetails'
import { demo } from 'page/catalog/store/CatalogStore'
import { itemPreview } from 'page/catalog/store/ItemPreviewStore'
import { opt } from 'store/opt'
import { formatPrice } from 'type/Item'
import css from './MainCard.module.scss'

export const MainCard = observer(() => {
  const { item } = itemPreview.it
  const mix = demo.it.canMix(item)
  const { descriptions } = demo.it.product.details ?? {}
  const { description, product_name, prices, images } = item
  const price = formatPrice(prices)
  const src = images[0]

  return <Space className={clsx(css.card, opt.sochi && css.sochi)} pad={32} round={24}>
    <Space className={css.center} gap={32} center>
      <Space className={css.left}>
        <Space className={css.image} ratio={demo.it.product.ratio || '3 / 4'}>
          <Image src={src} />
        </Space>
      </Space>
      <Vertical className={css.right} tall left center>
        <Vertical gap={24} maxHeight="100%">
          {mix && <Space className={css.mix} gap={8} pad={8} round>
            <Icon size={16} name="ai" />
            <Typo size={16} one medium upper>
              {i18n('CanBeCombined')}
            </Typo>
          </Space>}
          <Typo size={24} medium upper>
            {product_name}
          </Typo>
          {price && <Typo size={24} medium upper>
            {price}
          </Typo>}
          <ItemDetails />
          {descriptions && description && (
            <Vertical gap={4}>
              <Typo size={16} upper secondary>
                {i18n('demo.Description')}
              </Typo>
              <Space>
                <Typo size={20} pre wrap>
                  {description}
                </Typo>
              </Space>
            </Vertical>
          )}
        </Vertical>
      </Vertical>
    </Space>
  </Space>
})
